const STACK = [
  "Claude · Anthropic API", "Agentic systems", "TypeScript", "Python",
  "Next.js · React", "FastAPI", "Postgres + pgvector", "Redis",
  "LangGraph · LangChain", "Eval harnesses", "RAG pipelines", "Tool-use",
  "Custom MCP servers", "Plugin build pipelines", "Agent orchestration", "Skill authoring",
  "Docker · Compose", "Terraform", "AWS · Vercel", "Cloudflare",
  "Ubiquiti UniFi", "Home Assistant", "Proxmox · ZFS", "Self-hosted Linux",
  "Observability", "Postgres tuning",
];

export function Marquee() {
  // Doubled so the -50% keyframe loops seamlessly.
  const items = [...STACK, ...STACK];

  return (
    <section
      style={{
        position: "relative",
        padding: "32px 0",
        borderTop: "1px solid var(--hairline)",
        borderBottom: "1px solid var(--hairline)",
        background: "color-mix(in oklab, var(--paper-soft) 76%, transparent)",
        backdropFilter: "blur(6px)",
        overflow: "hidden",
      }}
    >
      <div
        className="marquee-mask"
        style={{
          position: "absolute", top: 0, bottom: 0, left: 0, width: 120, zIndex: 2,
          background: "linear-gradient(to right, var(--paper-soft), transparent)",
          pointerEvents: "none",
        }}
      />
      <div
        className="marquee-mask"
        style={{
          position: "absolute", top: 0, bottom: 0, right: 0, width: 120, zIndex: 2,
          background: "linear-gradient(to left, var(--paper-soft), transparent)",
          pointerEvents: "none",
        }}
      />

      {/* Wider than the viewport by design — see data-bleed in tests/smoke.spec.ts */}
      <div className="marquee" data-bleed>
        {items.map((entry, i) => (
          <span
            key={`${entry}-${i}`}
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: 12,
              letterSpacing: "0.04em",
              color: "var(--ink-3)",
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              gap: 12,
            }}
          >
            <span style={{ width: 4, height: 4, borderRadius: 999, background: "var(--ink-6)" }} />
            {entry}
          </span>
        ))}
      </div>
    </section>
  );
}
